import BaseComponent from "@js/components/base_component.jsx";

class EuiDefaultUrlDomain extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  render() {
    return (
      <Panel heading="default_url_domain">
        <form
          method="POST"
          action={ Routes.update_default_url_domain_eui_url_domains_path() }
        >
          <input type="hidden" name="_method" value="PUT" />
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: "70%" }}>URL Domain</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  { this._renderUrlDomain() }
                </td>
                <td className="index-buttons actions">
                  <input
                    type="hidden"
                    name="return_to"
                    value={ window.location.href }
                  />
                  <input
                    type="hidden"
                    name="authenticity_token"
                    value={ this.props.authenticity_token }
                  />

                  { this._renderButtons() }
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </Panel>
    );
  }

  _renderUrlDomain() {
    const hasUrlDomains = this.props.library.url_domains.length > 0;

    return this.state.editing ? (
      <SelectUrlDomain
        field="default_url_domain_url"
        value={ this.props.default_url_domain ? this.props.default_url_domain.domain : null }
        editing={ true }
        library={ this.props.library }
        blank={ this.props.default_url_domain.domain ? false : "none" }
        noLabel={ true }
        useDomainAsValue={ true }
      />
    ) : (
      <div>
        {
          !this.props.default_url_domain.domain ? (
            hasUrlDomains ? (
              <i>{ I18n.t("phrases.none_configured") }</i>
            ) : (
              <span>
                <i>{ I18n.t("phrases.none_configured") }</i> &mdash; { I18n.t("phrases.add_at_least_one_url_domain") }
              </span>
            )
          ) : this.props.default_url_domain.id ? (
            <a href={ Routes.eui_url_domain_path(this.props.default_url_domain.id) }>
              { this.props.default_url_domain.domain }
            </a>
          ) : (
            this.props.default_url_domain.domain
          )
        }
      </div>
    );
  }

  _renderButtons() {
    const allowEdit = this.props.library.system_configuration.allow_edit_url_domains;
    const hasUrlDomains = this.props.library.url_domains.length > 0;

    return this.props.hide_editing ? null : this.state.editing ? (
      <div>
        <ButtonCancel onClick={this._onCancelClicked} />
        <ButtonSave onClick={this._onSaveClicked} />
      </div>
    ) : allowEdit && hasUrlDomains ? (
      <div>
        <ButtonEdit onClick={this._onEditClicked} size="small" />
      </div>
    ) : (
      <div>
      </div>
    );
  }

  _onCancelClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ editing: false });
  }

  _onSaveClicked(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  _onEditClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ editing: true });
  }

}

export default EuiDefaultUrlDomain;
